// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__2nkjX","amount":"Amount_amount__3P82t","tip":"Amount_tip__3sd1X","tipHeader":"Amount_tipHeader__2UBqq","tipsWrap":"Amount_tipsWrap__338xd"};